import { DataTable, DataTablePagination } from "@/src/components/ui/data-table";
import { useEffect, useState } from "react";
import { optionsColumns } from "./optionsColumns";
import { useFetch } from "@/src/lib/useFetch";
import { useProvider, useOnlyOptions, useSort, useSupplier } from "./state";
import { Option } from "./model";
import { Dialog, DialogContent } from "@/src/components/ui/dialog";
import { EditOption } from "./EditOption";
import { useNavigate } from "react-router-dom";

type OptionsData = {
  data: Option[];
} & DataTablePagination;

export function OptionsTable() {
  const [options, setOptions] = useState<OptionsData>({
    data: [],
    total: 1,
    pagination: { page: 1, pageSize: 1 },
  });
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [page, setPage] = useState(1);

  const { fetch, isFetching } = useFetch();
  const navigate = useNavigate();

  const onlyOptions = useOnlyOptions();
  const provider = useProvider();
  const sort = useSort();
  const supplier = useSupplier();

  const fetchOption = (id: string) => fetch<{ data: Option }>(`/api/options/option/${id}`);

  const fetchOptions = (page: number) =>
    fetch<OptionsData>(
      `/api/options/options?page=${page}&order=${sort}&provider=${provider}${onlyOptions ? "&only=options" : ""}${
        supplier ? `&supplier=${encodeURIComponent(supplier)}` : ""
      }`,
    );

  useEffect(() => {
    fetchOptions(page).then((data) => {
      setOptions(data);
    });
  }, [page, sort, onlyOptions, provider, supplier]);

  return (
    <div className="rounded-md bg-white border">
      <Dialog
        open={!!selectedOption}
        onOpenChange={() => {
          setSelectedOption(null);
          fetchOptions(page).then((data) => setOptions(data));
        }}
      >
        <DialogContent>
          <EditOption option={selectedOption ?? undefined} />
        </DialogContent>
      </Dialog>
      <DataTable
        isLoading={isFetching}
        columns={optionsColumns((r) => fetchOption(r.id).then(({ data }) => setSelectedOption(data)))}
        data={options.data}
        pagination={options}
        onPageClick={(p) => setPage(p)}
        onRowClick={(r) => (r.offer?.offer.id ? navigate(`/offers/${r.offer?.offer.id}`) : undefined)}
      />
    </div>
  );
}
